import { render, staticRenderFns } from "./orderwholesalelist.vue?vue&type=template&id=c437a132"
import script from "./orderwholesalelist.vue?vue&type=script&lang=js"
export * from "./orderwholesalelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports